import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4201c5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changelog" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "changelog__entry__meta" }
const _hoisted_6 = { class: "changelog__entry__user" }
const _hoisted_7 = { class: "changelog__entry__time" }
const _hoisted_8 = { class: "changelog__entry__changes" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('proposal.changelog.loading')), 1))
      : (!_ctx.entries.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('proposal.changelog.empty')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "changelog__entry"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(entry.userName || _ctx.$t('proposal.changelog.unknown_user')), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatTimestamp(entry.createdAt)), 1)
                ]),
                _createElementVNode("ul", _hoisted_8, [
                  (entry.action === 'created')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_ctx.$t('proposal.changelog.created')), 1))
                    : _createCommentVNode("", true),
                  (entry.changes?.status)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_ctx.$t('proposal.changelog.status_change', {
                from: _ctx.statusLabel(entry.changes.status[0]),
                to: _ctx.statusLabel(entry.changes.status[1])
              })), 1))
                    : _createCommentVNode("", true),
                  (entry.changes?.description)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_ctx.$t('proposal.changelog.description_change')), 1))
                    : _createCommentVNode("", true),
                  (entry.changes?.validFrom)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(_ctx.$t('proposal.changelog.valid_from_change', {to: _ctx.formatDate(entry.changes.validFrom[1])})), 1))
                    : _createCommentVNode("", true),
                  (entry.changes?.validTo)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString(_ctx.$t('proposal.changelog.valid_to_change', {to: _ctx.formatDate(entry.changes.validTo[1])})), 1))
                    : _createCommentVNode("", true),
                  (entry.pricesUpdated)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, _toDisplayString(_ctx.$t('proposal.changelog.prices_updated')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
  ]))
}